<template>
  <div class="container">
    <div class="container_one" v-loading="oneloading">
      <div class="header">
        <div></div>
        <div class="tabs-container">
          <span :class="isActive == '0' ? 'active' : ''" @click="isActive = '0'"
            >回路</span>
          <span :class="isActive == '1' ? 'active' : ''" @click="isActive = '1'"
            >类型</span
          >
        </div>
      </div>
      <div class="monthly">
        月用电量：
        <span>
          <b v-if="isActive == '0'">{{loopNumber}}</b>
          <b v-else-if="isActive == '1'">{{typeNumber}}</b>
          <span style="font-size:18rem">kWh</span>
        </span>
      </div>
      <div style="height:25vh">
        <charts id="ElectricityCharts" :option="ElectricityOption"></charts>
      </div>
    </div>
    <div class="container_two" >
      <div class="header">
        <div class="title">月用电曲线</div>
        <div class="tabs-container">
          <span :class="isActive == '0' ? 'active' : ''" @click="isActive = '0'"
            >回路</span
          >
          <span :class="isActive == '1' ? 'active' : ''" @click="isActive = '1'"
            >类型</span
          >
        </div>
      </div>
      <div style="height:28vh">
        <charts id="curve" :option="curveOption"  v-if="!iscurveOption"></charts>
        <div  class="row-center tip" v-else style="height:100%"><img :src="require('../../../assets/img/not_found_data.png')" alt=""></div>
      </div>
    </div>
    <div class="container_three" v-loading="oneloading">
      <div class="header">
        <div class="title" v-if="isActive=='0'">本月能耗前十</div>
        <div class="title" v-if="isActive=='1'">月用电排名</div>
        <div class="tabs-container">
          <span :class="isActive == '0' ? 'active' : ''" @click="isActive = '0'"
            >回路</span
          >
          <span :class="isActive == '1' ? 'active' : ''" @click="isActive = '1'"
            >类型</span
          > 
        </div>
      </div>
      <div class="energy">
        <ul>
          <li v-for="(item, index) in EnergyList" :key="index">
            <div class="name" :title="item.loopName">{{ index + 1 }}.{{ item.loopName }}:</div>
            &nbsp;&nbsp;&nbsp;{{item.sum.toFixed(2)}}kWh
            <!-- <span v-if="item.order == 'up'" style="color:#FC2E32">
              <img src="../../../assets/img/up.png" width="15" />
              {{ index + 1 }}
            </span>
            <span v-else-if="item.order == 'down'" style="color:#5AD8A6">
              <img src="../../../assets/img/down.png" width="15" />
              {{ index + 1 }}
            </span>
            <span v-else style="color:#5B8FF9">
              <img src="../../../assets/img/arrow-line.png" width="12" />
              {{ index + 1 }}
            </span> -->
          </li>
        </ul>
      </div>
    </div>
    <chainratio></chainratio>
  </div>
</template>

<script>
const echarts = require("echarts");
import charts from "../../../components/Energy/charts";
import chainratio from "../../../components/Energy/chain";

import {
        floatFormat
    } from "../../../util/MathUtil";
import {
    overviewPowerNumber,
    PowerNumber,
    mainloopMonth,
    powerConsumptionarea
} from "../../../api/power";
export default {
  props: {
    routeName: String,
  },
  components: {
    charts,
    chainratio,
  },
  data() {
    return {
      isChain: 1,
      isActive: 0,
      xmonth:[],
      looplist:[],
      loopNumber:"",
      typeNumber:"",
      monthData:[],
      monthChart:[],
      typesChart:[],
      rankingData:[],
      iscurveOption:false,
      listChart:[],
      oneloading:true
    };
  },
  computed: {
    ring() {
      let day = "期";
      // if (this.isChain == "0") {
      //   day = "日";
      // } else if (this.isChain == "2") {
      //   day = "年";
      // }
      return [
        {
          id: 1,
          class: [
            {
              id: 1,
              name: "本",
            },
            {
              id: 2,
              name: day,
            },
            {
              id: 3,
              name: "用",
            },
            {
              id: 4,
              name: "电:",
            },
          ],
          data: "4554",
        },
        {
          id: 2,
          class: [
            {
              id: 1,
              name: "上",
            },
            {
              id: 2,
              name: day,
            },
            {
              id: 3,
              name: "用",
            },
            {
              id: 4,
              name: "电:",
            },
          ],
          data: "5455",
        },
        {
          id: 3,
          class: [
            {
              id: 1,
              name: "同",
            },
            {
              id: 2,
              name: "比",
            },
            {
              id: 3,
              name: "率:",
            },
          ],
          data: "100",
        },
        {
          id: 4,
          class: [
            {
              id: 1,
              name: "累",
            },
            {
              id: 2,
              name: "计",
            },
            {
              id: 3,
              name: "同",
            },
            {
              id: 4,
              name: "比:",
            },
          ],
          data: "100",
        },
      ];
    },
    same() {
      let day = "月";
      if (this.isChain == "0") {
        day = "日";
      } else if (this.isChain == "2") {
        day = "年";
      }
      return [
        {
          id: 1,
          class: [
            {
              id: 1,
              name: "本",
            },
            {
              id: 2,
              name: day,
            },
            {
              id: 3,
              name: "用",
            },
            {
              id: 4,
              name: "电:",
            },
          ],
          data: "4554",
        },
        {
          id: 2,
          class: [
            {
              id: 1,
              name: "上",
            },
            {
              id: 2,
              name: day,
            },
            {
              id: 3,
              name: "用",
            },
            {
              id: 4,
              name: "电:",
            },
          ],
          data: "5455",
        },
        {
          id: 3,
          class: [
            {
              id: 1,
              name: "环",
            },
            {
              id: 2,
              name: "比",
            },
            {
              id: 3,
              name: "率:",
            },
          ],
          data: "100",
        },
        {
          id: 4,
          class: [
            {
              id: 1,
              name: "增",
            },
            {
              id: 2,
              name: "长",
            },
            {
              id: 3,
              name: "值:",
            },
          ],
          data: "100",
        },
      ];
    },
    EnergyList() {
      if (this.isActive == "0") {
        return this.looplist
      } else {
        return this.typesChart
      }
    },
     curveOptionData() {
      if (this.isActive == "0") {
        return this.monthData
      } else {
        return this.monthChart
      }
    },
    curveOption() {
      return {
        color: ["#5B8FF9", "#F6BD16", "#E8684A", "#6DC8EC"],
        tooltip: {
          trigger: "axis",
          formatter: function(params){
            let str = `${params[0].name}日<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}: ${item.data}`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
      　　}
        },
        legend: {
          orient: "vertical", //垂直显示
          y: "10%", //延Y轴居中
          x: "right", //居右显示
          icon: "rect",
          align:"left",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            fontSize: 15,
            fontWeight: 800,
            width:20
          },
          formatter: function(name){
      　　　　return name.length>4?name.substr(0,4)+"...":name;
      　　}
        },
        grid: {
          left: "0%",
          right: "10%",
          bottom: "1%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          name:"日",
          nameTextStyle: {
            color: "#999999",
          },
          type: "category",
          boundaryGap: false,
          data: this.xmonth,
          splitLine: {
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#CCCCCC",
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            //x轴文字的配置
            show: true,
            textStyle: {
              color: "#999999",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "kWh",
        },
        series: this.curveOptionData,
      };
    },
    ElectricityOptionData() {
      if (this.isActive == "0") {
        return this.listChart
      } else {
        return this.typesChart
      }
    },
    ElectricityOption() {
      return {
        // color: ["#5B8FF9", "#6DC8EC", "#F6BD16", "#E8684A"],
        tooltip: {
          trigger: "item",
          position: 'top',
          formatter: function(obj){
            return obj.marker+obj.name+"："+obj.value
          }
        },
        legend: {
            orient: "vertical", //垂直显示
            y: "center", //延Y轴居中
            x: "2%", //居右显示
            icon: "rect",
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 14,
            textStyle: {
              fontSize: "16rem",
              fontWeight: 800,
              width:20
            },
            formatter: function(name){
          　　　　return name.length>8?name.substr(0,8)+"...":name;
          　}
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "55%"],
            center: ['65%', '50%'],
            // roseType: 'area',
            label: {
              // formatter: "{name|{b}}\n{time|{d}%}",
              formatter: "{time|{d}%}",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 25,
              fontSize: 15,
              fontWeight: 800,
              rich: {
                time: {
                  fontSize: 15,
                  color: "#0D94FF",
                  fontWeight:800
                },
              },
            },
            itemStyle: { // 此配置
                normal: {
                    borderWidth: 1,
                    borderColor: '#ffffff',
                },
            },
             labelLine: {
                  length: 5,
                  length2: 5,
                  show: true,
                  lineStyle:{
                    width:2
                  }
                  // color: "#00ffff",
              },
            data: this.ElectricityOptionData,
          },
        ],
      };
    },
  },
  
  mounted() {
    for(let i = 0; i <= 30; i++){
				this.xmonth.push(i+1)
		}
    this.getLooplist();
    this.getLooplistMum();
    this.getLoopData();
    this.getMonthChart();
  },
  methods: {
    async  getMonthChart(){
        let response = await powerConsumptionarea();
        let list  = response.data.data.curve || [];
        let percentage  = response.data.data.percentage || [];
        this.typeNumber = response.data.data.total.toFixed(2);
        percentage.map((e)=>{
          let name="",num=""
          for (let i in e) {
            name = i
            num = e[i]
          }
           this.typesChart.push({
                name: name,
                loopName:name,
                sum:num,
                value: num.toFixed(2),
             })
        })
        // for (let i in percentage) {
        //  this.typesChart.push({
        //     name: i,
        //     loopName:i,
        //     sum:percentage[i],
        //     value: percentage[i],
        //  })
        // }
        for (i in list) {
          let data = []
          list[i].forEach(e=>{
            data.push(e.toFixed(2))
          })
         this.monthChart.push({
            name: i,
            type: "line",
            data: data,
         })
        }
    },
    
    async  getLooplistMum(){
        let response = await overviewPowerNumber();
        let list = response.data.data.list || [];
        let n = 0
        list.map(e=>{ 
          n+=e.sum; 
        })
        this.loopNumber = n.toFixed(2); 
    },
    async  getLooplist(){
        let response = await PowerNumber();
        this.looplist = response.data.data.list.slice(0,10) || [];
        let num = 0
        let total = 0
        response.data.data.list.forEach((item,index)=>{
          total+=item.sum
          if(index<=2){
            this.listChart.push({
              value:item.sum.toFixed(2),
              name:item.loopName
            })
          }else{
            num+=item.sum
          }
        })
        this.listChart.push({
          value:num.toFixed(2),
          name:"其他"
        })
        // this.loopNumber = total.toFixed(2); 
        this.oneloading = false
    },
    async getLoopData(){
      let response = await mainloopMonth("MONTH");
      let list = response.data.data.points || [];
      let num = 0
      let total = 0
      let data = []
      for(let j = 0; j < new Date().getDate() ; j++){
        data.push(0)
      }
        if(list){
          for(var i in list){
            total ++
            let len = list[i].length
            
            if(list[i].length>0){
              list[i].forEach((element,index) => {
                let val = Number(element.val)
                let num = Number(data[index])+val
                data[index] = floatFormat(num,2)
              });
            }else{
              num ++
            }
          }
          this.monthData.push({
            name: "总用电量",
            type: "line",
            data:data
          })
          if(num==total){
            this.iscurveOption = true
          }
        }else{
          this.iscurveOption = true
        }
    }
  },
};
</script>

<style scoped lang="less">
.container {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: space-between;
  align-content: space-between;
  font-size: 18rem;
  .header {
    display: flex;
    justify-content: space-between;
    // padding-left: 24rem;
    // padding-right: 24rem;
    // height: 64rem;
    // line-height: 64rem;
    .title {
      font-size: 18rem;
      font-weight: 700;
      color: #333;
    }
    .tabs-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      span {
        height: 40rem;
        border-top: 2px solid #fff;
        font-size: 18rem;
        font-weight: 400;
        margin: 0 10rem;
        cursor: pointer;
        font-weight: bold;
      }
      .active {
        color: #0d94ff;
      }
    }
  }
  .container_one {
    width: 24vw;
    height: 35vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_two {
    width: 59vw;
    height: 35vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_three {
    width: 24vw;
    height: 53.5vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_four {
    width: 59vw;
    height: 53.5vh;
    justify-content: space-between;
    align-content: space-between;
    display: flex;
    flex-wrap: wrap;
  }
  .chain {
    background: #ffffff;
    padding: 20rem;
    height: 26vh;
    width: 100%;
  }
  .energy {
    li {
      height: 40rem;
      line-height: 40rem;
      margin-top: 8rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      font-size: 18rem;
      overflow: hidden;
      .name{
        display: inline-block;
        max-width: 70%;
        text-overflow: ellipsis;
        overflow: hidden;
        vertical-align: -11px;
        white-space: nowrap;
      }
      span {
        // margin-left: 45rem;

        
        font-weight: bold;
        font-size: 18rem;
        float: right;
        width: 50rem;
        text-align: left;
        img {
          vertical-align: middle;
        }
      }
    }
  }
  .monthly {
    padding-left: 20rem;
    font-weight: bold;
    span {
      font-size: 30rem;
      color: #0d94ff;
      font-weight: 400;
      i {
        font-size: 18rem;
      }
    }
  }
  .used {
    padding-top: 20rem;
    padding-left: 30rem;
    float: left;
    .line {
      display: flex;
      margin-bottom: 20rem;
      align-items: center;
      &:before {
        content: "";
        width: 6rem;
        height: 6rem;
        border-radius: 50%;
        background: #666;
        vertical-align: middle;
        margin-right: 10rem;
      }
      .totol {
        font-size: 21rem;
        font-weight: 400;
        color: #666;
        width: 120rem;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;
        i {
          font-style: initial;
        }
      }
      .parameter {
        font-size: 16rem;
        margin-left: 8rem;
        span {
          font-size: 20rem;
          font-weight: bold;
          margin-right: 5rem;
        }
      }
    }
  }
}
</style>
